<!-- <p>profile-component works!</p> -->
<div class="container_cus">
	<!-- <div class="profile_page_cont" *ngIf="show_pofile"> -->
	<div class="profile_page_cont">
		<div class="profile_sidebar_cont">
			<fb-profile-sidebar></fb-profile-sidebar>
		</div>
		<div class="profile_router_outlet_cont_cont">
			<router-outlet></router-outlet>
		</div>
	</div>
</div>

